export const name = "SECH";
export const summary = `Computes the hyperbolic secant of \`X\`.`;
export const reference = `
## SECH

Computes the hyperbolic secant of \`X\`.

\`\`\`
SECH(X)
\`\`\`

### Description

Computes the hyperbolic secant for the angle of \`X\`, where \`X\` is specified in radians. \`X\` can be any data type that coerces to \`FLOAT64\`. Never produces an error.

| X | SECH(X) |
| --- | --- |
| \`+inf\` | \`0\` |
| \`-inf\` | \`0\` |
| \`NaN\` | \`NaN\` |
| \`NULL\` | \`NULL\` |


### Return Data Type

\`FLOAT64\`


### Example



\`\`\`
SELECT SECH(0.5) AS a, SECH(-2) AS b, SECH(100) AS c;

/*----------------+----------------+---------------------*
 | a | b | c |
 +----------------+----------------+---------------------+
 | 0.88681888397 | 0.265802228834 | 7.4401519520417E-44 |
 *----------------+----------------+---------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
